import { React, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {getFormattedDate,isEndDateGreater,changeDateFormat,getMonthsBetween} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import axios from 'axios';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {getMonthlyWholeSaleReportData}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

function MonthlyWholeSalePriceItemwiseReport() {

    const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const storedLanguage = localStorage.getItem('language');
    const today = new Date();
    const config = getAuthHeaders();

 
  

   
   
   
   //handle excel sheet ***************
const handleGenerateExcel = async() => {

    if (!startDate || !endDate) {
        toast.error('Please select the date range', messages.COLOR_RED);
        return;
      }
      if(!isEndDateGreater(startDate,endDate)){
          toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
          return;
        }

        let sDate= getFormattedDate(startDate);
        let eDate=  getFormattedDate(endDate);

    try {
    showLoading(true);

        let post_data={
            fromDate: sDate,
            toDate:eDate
        }

        const response = await axios.post(`${API_URL}api/price/MonthlyWholeSalePriceItemwiseReport`, post_data, config);
        const reportData = response.data;
       if(reportData.status){
            let allData= reportData.data[0].GroupCodes;
            downloadReport(allData,sDate,eDate)

        }else{
          toast.error('Data is not found', messages.COLOR_RED);
        }
      
   } catch (error) {
    console.error(error);

    }finally{
    showLoading(false);
    }
   }


const formatGrossValue = (value) => {
    if (value === 0) return '0.00';
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return '';
    return Number(value).toFixed(2);
};
   
   
   
   const downloadReport=(allData,sDate,eDate)=>{

     const prices = allData.map(item => {
        let price = item.WHOLESALE_PRICES.map(itemPrice => formatGrossValue(itemPrice.price));
          return  price ;
      });

    const transformedData = allData.map((item ,index)=>{

       return [item.DISTRICT_CODE,
       item.ITEM_CODE,
       item.con,
       item.DISTRICT_NAME,
       item.ITEM_NAME,
       item.ITEM_VARIETY_NAME,
       item.ITEM_UNIT_NAME,
       formatGrossValue(item.BASE_YEAR_PRICE) ,
       ...prices[index]
       ]

    })


    let excelObjectData = {
         fileName:`MonthlyWholeSalePriceItemwiseReport(${sDate.replace(/ /g, "_")}-${eDate.replace(/ /g, "_")})`,
         fileType:'xls',
         sheetName: 'WholeSaleInput',
         firstRowMergeCells: 'A1:I1',
         firstRowExportDate:  changeDateFormat(new Date()),
         secondRowMergeCells: 'A2:I2',
         secondRowText: `Monthly WholeSale Price Itemwise Report (${sDate}-${eDate})`,
         headerEnglishColumns:['Dist Code','Item Code','Con','Center','Item','Variety Name','Unit',
            'BASE YEAR PRICE 2011-12',...getMonthsBetween(sDate,eDate,'WHOLESALE PRICE IN')],
        excelRowData:transformedData,
       };


        excelObjectData.excelRowData = transformedData;
        getMonthlyWholeSaleReportData(excelObjectData);
     }
   
     return (
       <>
           <ToastContainer />
           <GlobalLoading />
           <div className="container-fluid py-3">
               <div className="card mx-3 mb-3">
                   <div className="card-body pb-1">
                       <div className="row align-items-center">
                           <h4 className="page_heading">
                               <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.MON_WHOLE_SALE_PRICE_ITEM_WISE_REPORT : priceTitle.en.MON_WHOLE_SALE_PRICE_ITEM_WISE_REPORT }} />
                           </h4>
                           <div className="row align-items-center">
                           
                           
                           <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">From Date</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        selected={startDate}
                                        onChange={(e) => { setStartDate(e) }}
                                        dateFormat="MMM yyyy"
                                        showMonthYearPicker
                                        placeholderText="Select month"
                                        maxDate={today}
                                    />
                                </div>
   
   
                           <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">To Date</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        selected={endDate}
                                        onChange={(e) => { setEndDate(e) }}
                                        dateFormat="MMM yyyy"
                                        showMonthYearPicker
                                        placeholderText="Select month"
                                        maxDate={today}
                                    />
                                </div>
   
   
                           <div className="col-xl-2 col-lg-4 mb-3">
                               <label className="w-100 d-none d-sm-block">&nbsp;</label>
                               <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                           </div>
                           </div>
   
   
                       </div>
                   </div>
               </div>
           </div>
      </>
     )
   }

export default MonthlyWholeSalePriceItemwiseReport